import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = {
  key: 0,
  class: "breadcrumb-title"
}
const _hoisted_3 = { class: "breadcrumb-title-text" }
const _hoisted_4 = { class: "breadcrumb-actions" }

import { ArrowRight, HomeFilled } from '@element-plus/icons-vue'


export default {
  __name: 'Breadcrumb',
  props: {
  title: {
    type: String,
    default: ''
  },
  current: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

const route = useRoute()

const breadcrumb = computed(() => {
  return route.matched.filter(v => v.components).map(item => ({
    title: (item.path === route.path ? props.current : '') || item.meta.title,
    path: item.path
  }))
})


return (_ctx, _cache) => {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_breadcrumb, { "separator-icon": _unref(ArrowRight) }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumb), (item) => {
          return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: item.path,
            to: item.path
          }, {
            default: _withCtx(() => [
              (item.path === '/')
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        name: "home.png",
                        size: 12
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ], 64))
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["separator-icon"]),
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.title) + " ", 1),
            _renderSlot(_ctx.$slots, "title-extra")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "actions")
    ])
  ]))
}
}

}